var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"w-full",class:{'o-hidden':_vm.o_hidden}},[_c('div',{staticClass:"relative top-0",class:{'o-hidden':_vm.o_hidden},attrs:{"radio":_vm.RadioValue}},[_vm._t("default"),_vm._v(" "),_c('div',{staticClass:"radioclass",style:({paddingTop:_vm.RadioValue + '%'})})],2)])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-45cc9d8a","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/common/RatioDiv.vue
// module id = null
// module chunks = 